import { useState } from "react";
import "../sign.css";
import ASSETS from "../../../app/config/assets";
import Logo from "../../../ui/atoms/logo/Logo";
import ThemeSwitcher from "../../../ui/molecules/theme-switcher/ThemeSwitcher";
import LanguageSelector from "../../../ui/molecules/languages/LanguageSelector";
import MessageBox from "../../../ui/atoms/message-box/MessageBox";
import InputText from "../../../ui/atoms/inputs/input-text/InputText";
import Button from "../../../ui/atoms/buttons/Button";
import Loading from "../../../ui/atoms/loading/Loading";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
//
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { wait } from "../../../core/utils/helpers";
import { LoginSchema } from "../../../core/utils/validators/authentication";
//
import { login } from "../services/authentication";
import { useDispatch } from "react-redux";
import { setCredentials } from "../../../app/store/slices/authSlice";
import { configurationSlice } from "../../../app/store/slices/configurationSlice";

const SignIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isSending, setIsSending] = useState(false);
  const [isShowingMsgBox, setIsShowingMsgBox] = useState(false);
  const [messageData, setMessageData] = useState({ type: "", text: "" });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(LoginSchema),
  });

  const onSubmit = async (data) => {
    setIsSending(true);
    await wait(700);
    //
    login(data)
      .then((response) => {
        setIsSending(false);
        const _data = response?.data;
        
        if (_data?.isLogged) {
          //
          dispatch(configurationSlice.actions.setCurrentConnectedStream(null));
          dispatch(configurationSlice.actions.setCurrentConversation(null));
          // 
          // Redirect to the appropriate dashboard based on the user's role
          const accessToken = _data?.accessToken;
          const sys_role = _data?.sys_role;
          const to = "/" + sys_role;

          // ✅ REDUX REMPLACE setAuth
          dispatch(
            setCredentials({
              accessToken,
              sys_role,
            }),
          );

          reset();

          navigate(to, { replace: true });
        } else {
          setIsShowingMsgBox(true);
          setMessageData({ type: "warning", text: _data?.message });
          //
          const timer = setTimeout(() => {
            setIsShowingMsgBox(false);
            setMessageData({ type: "", text: "" });
          }, 4000);
          return () => clearTimeout(timer);
        }
      })
      .catch((error) => {
        setIsSending(false);
        setIsShowingMsgBox(true);
        if (!error?.response) {
          setMessageData({ type: "info", text: "No server response" });
        } else {
          setMessageData({
            type: "warning",
            text: error?.response?.data?.detail?.message,
          });
        }
        const timer = setTimeout(() => {
          setIsShowingMsgBox(false);
          setMessageData({ type: "", text: "" });
        }, 2000);
        return () => clearTimeout(timer);
      });
  };

  return (
    <div className="w-screen h-screen position-relative bg-primary d-flex">
      <div className="w-60 h-full sign-section to-hide position-relative bg-primary d-flex justify-center align-center">
        <img src={ASSETS?.signin} alt="Sign In" className="w-full radius-md" />
      </div>
      <div className="w-40 h-full sign-section position-relative bg-white p-sm">
        <div className="sign-head w-full d-flex justify-space-between align-center">
          <Logo to={"/"} width={"100px"} />
          <div className="sign-switchers d-flex justify-space-between align-center">
            <ThemeSwitcher />
            <LanguageSelector />
          </div>
        </div>
        <form
          className="sign-body w-full d-flex justify-center align-center flex-col pl-lg pr-lg"
          onSubmit={handleSubmit(onSubmit)}
        >
          <h1 className="mb-lg">{t("sign.sign_in")}</h1>
          {isShowingMsgBox && (
            <div className="w-full mb-xs">
              <MessageBox type={messageData?.type} msg={messageData?.text} />
            </div>
          )}
          <div className="w-full mt-md">
            <InputText
              type={"text"}
              register={register}
              name="mail"
              title={t("user.email")}
              error={errors?.mail?.message}
            />
          </div>
          <div className="w-full mt-md">
            <InputText
              type={"password"}
              register={register}
              name="password"
              title={t("user.password")}
              error={errors?.password?.message}
            />
          </div>
          <div className="w-full mt-lg">
            {isSending ? (
              <Loading type={"type-1"} />
            ) : (
              <Button
                type={"submit"}
                preferedStyle={"normal"}
                title={t("sign.sign_in")}
                action={null}
              />
            )}
          </div>
        </form>
        <div className="sign-foot w-full d-flex justify-center align-center">
          <span className="sign-foot-text">{t("sign.no_account")}</span>
          <Link to={"/signup"} className="sign-links ml-xs">
            <span>{t("sign.sign_up")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
